/* RESPONSIBLE TEAM: team-ai-agent */
import ConversationsController from 'embercom/controllers/apps/app/automation/fin-ai-agent/custom-answers/answer/show/conversations';

export default class ResolutionBotAnswersAnswerShowConversationsController extends ConversationsController {}
